
import PopinManager from 'Services/PopinManager'

export default {
    data() {
        return {
            popin: new PopinManager(),
        }
    },
    methods: {
        callNextPopin(key) {
            return new Promise((resolve, reject) => {
                this.popin.next(key).then(response => {
                    this.popin.process(response)
                    resolve()
                })
            })
        }
    }
}